export const INTERNAL_IMAGES_UPLOAD_PATH =
  "uploads/educational-center/internal-training";
export const INTERNAL_IMAGES_BASE_URL = `${process.env.API_URL}/${INTERNAL_IMAGES_UPLOAD_PATH}`;
